import React from "react";
import { Link } from "react-router-dom";
import Moment from 'react-moment';
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import $ from 'jquery'
import "react-datepicker/dist/react-datepicker.css";
import * as userActions from "../../actions/usersActions";
import * as constant from '../../constants/constant';
import * as dashboardActions from "../../actions/dashboardActions";

class Notifications extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			notifications: [],
			isNotificationLoaded: true
		};
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this._logout = this._logout.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.clearNotifications = this.clearNotifications.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);


	}
	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.actions.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle(e) {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	componentWillMount() {
		var obj = {
			userId: localStorage.getItem('userId')
		}
		this.props.actions.getUserNotifications(obj)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.notifications && this.state.isNotificationLoaded) {
			this.setState({
				notifications: nextProps.notifications,
				isNotificationLoaded: false
			})
		}

	}
	clearNotifications() {
		let obj = {
			userId: localStorage.getItem('userId')
		}
		this.props.actions.clearNotifications(obj);
		this.setState({
			notifications :[]
		})
	}

	componentDidMount() { }
	myFunction(index, e) {

		var dots = document.getElementById("dots" + index);
		var moreText = document.getElementById("more" + index);
		var btnText = document.getElementById("myBtn" + index);

		if (dots.style.display === "none") {
			dots.style.display = "inline";
			btnText.innerHTML = "Read more >";
			moreText.style.display = "none";
		} else {
			dots.style.display = "none";
			btnText.innerHTML = "Read less >";
			moreText.style.display = "inline";
		}
	}



	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		var userType = localStorage.getItem('userType');
		var notifications = this.state.notifications;
		var address = this.state.address;
		var userData = JSON.parse(localStorage.getItem('user'))
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		var imagesPath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + 'admin/';
		if (user.adminImage == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'
			}
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2')
		// {this.onrenderimage()}
		var rows = [];
		var rowsOld = [];
		notifications.forEach(
			function (item, index) {
				console.log("--------------------__>", item)
				var now = moment(new Date()); //todays date
				// var end = moment("2015-12-1"); // another date
				var days = moment(item.createdAt).fromNow();

				var start = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSSZ')
				var end = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSSZ')
				var createdDate = moment(item.createdAt).format('YYYY-MM-DDTHH:mm:ss.SSSSZ')
				if (createdDate >= start && createdDate <= end) {
					rows.push(
						<div className="row m-t borBottoms" key={index}>
							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<span>
									<i className="fa fa-clock-o" aria-hidden="true" />
								</span>
								<span> {days}</span>
							</div>

							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<div className="welcome">
									<h3>{item.subject} </h3>
									<span style={{ display: "inline" }} id={"dots" + index}>...</span><span style={{ display: "none" }} id={"more" + index}>
										<div className>
											<div className="cbp-vm-icon cbp-vm-close clos">
												<Link to="#" />
											</div>
										</div>
										<p dangerouslySetInnerHTML={{ __html: item.content }}>
										</p>
									</span>
									<p id={"myBtn" + index} style={{ cursor: "pointer" }} onClick={this.myFunction.bind(this, index)} className="readmore">
										READ MORE >
		                          </p>

								</div>
							</div>
						</div>
					);
				} else {
					rowsOld.push(
						<div className="row m-t borBottoms" key={index}>
							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<span>
									<i className="fa fa-clock-o" aria-hidden="true" />
								</span>
								<span>{days}</span>
							</div>

							<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
								<div className="welcome">
									<h3>{item.subject} </h3>
									<span style={{ display: "inline" }} id={"dots" + index}>...</span><span style={{ display: "none" }} id={"more" + index}>
										<div className="cbp-vm-icon cbp-vm-close clos">
											<Link to="#" />{" "}
										</div>
										<p dangerouslySetInnerHTML={{ __html: item.content }}>
										</p>
									</span>
									<p id={"myBtn" + index} style={{ cursor: "pointer" }} onClick={this.myFunction.bind(this, index)} className="readmore">
										READ MORE >
		                          </p>
								</div>
							</div>
						</div>
					);
				}
			}.bind(this)
		);
		return (
			<div>
				{userType == 'specialist' ? <header className="main-header">
				<Link to={condition ? "/specialist/my-appointment":null} className="logo">						<span className="logo-mini">{userType === 'specialist' ?<img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" />: <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ?<img src={require('../../images/img/logo_er.png')} alt="" />: <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle.bind(this)}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
					: ''
				}
				<div className="content-wrapper" >
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs custom-nav">
											<li>
												<Link
													to="#tab_1"
													data-toggle="tab"
													className="active show"
												>
													All Notifications
											</Link>
											</li>
											<li>
											<button
												type="button"
												className="btn btn-square btn-w-120"
												data-toggle="modal"
												data-target="#modal-default"
												onClick={this.clearNotifications}
											>
												Clear All
                    </button>
											</li>
										</ul>
										{/* <div className="bottomBtn p-none posabst">
											<button
												type="button"
												className="btn btn-square mb-3"
												data-toggle="modal"
												data-target="#modal-default"
												onClick={this.clearNotifications}
											>
												Clear All
                    </button>
										</div> */}
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother">
													<div className="row borBottom">
														<div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
															<div className="form-group checkcustom ">
																{/* <div className="checkbox checkbox-primary">
																<input
																	type="checkbox"
																	name="radio1"
																	id="checkbox"
																	value="option1"
																/>
																<label htmlFor="checkbox" className="startReview">
																	<span>Read/Unread</span>
																</label>
															</div> */}
															</div>
														</div>
														<div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
															<div className="todayDate">
																<h4>Today - <Moment className="datetime" format=" Do MMMM YYYY"></Moment> </h4>
															</div>
														</div>
													</div>
													{rows && rows.length > 0 ? (
														rows
													) : (
															<div style={{ 'textAlign': 'center' }}><h5>No Notifications</h5></div>
														)}
													<div className="row borBottom">
														<div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
															<div className="form-group checkcustom ">
																{/* <div className="inputcheck">
																<input type="checkbox" id="ht1" />
																<label htmlFor="ht1">Read/Unread</label>
															</div> */}
															</div>
														</div>
														<div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
															<div className="todayDate">
																<h4>Old Notifications</h4>
															</div>
														</div>
													</div>
													{rowsOld && rowsOld.length > 0 ? (
														rowsOld
													) : (
															<div>No Notifications</div>
														)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		notifications: state.users.userNotifications
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...userActions, ...dashboardActions }, dispatch)
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Notifications);
